import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faLocationDot, faLink, faUtensils, faPhone, faStar } from '@fortawesome/free-solid-svg-icons';

const formatDistance = (miles) => {
    if (miles == null) return null;
    if (miles < 0.1) return '<0.1 mi';
    if (miles < 10)  return `${miles.toFixed(1)} mi`;
    return `${Math.round(miles)} mi`;
};

const MyFavoriteRestaurants = ({ restaurant, index, onIdCollected }) => {
    const rJson = restaurant.restaurant_json;

    const restaurantId  = rJson?.id || restaurant.restaurant_id;
    const name          = rJson?.name || restaurant.artist_name;
    const area          = rJson?.address || rJson?.area || '';
    const cuisineType   = rJson?.cuisine || '';
    const foodEmoji     = rJson?.foodEmoji || '🍽️';
    const website       = rJson?.website || null;
    const phone         = rJson?.phone || null;
    const opening_hours = rJson?.opening_hours || null;
    const stars         = rJson?.stars != null ? parseFloat(rJson.stars) : null;
    const distanceMiles = rJson?.distanceMiles ?? null;

    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(name + (area ? ' ' + area : ''))}`;
    const menuUrl = website ||
        `https://www.google.com/search?q=${encodeURIComponent(name + (area ? ' ' + area : '') + ' menu')}`;

    useEffect(() => {
        if (onIdCollected && restaurantId) onIdCollected(restaurantId, rJson);
    }, [restaurant, onIdCollected, restaurantId, rJson]);

    if (!rJson) return null;

    return (
        <div className="flex justify-between gap-x-6 py-5">
            <div className="flex min-w-0 gap-x-4">
                <div className="flex-shrink-0 place-self-center text-sm">{index + 1}</div>

                <div className="flex-none">
                    <a href={mapsUrl} target="_blank" rel="noreferrer"
                       restaurantid={restaurantId} restaurantname={name}>
                        <div className="Food_Photo_Placeholder">
                            <span className="text-3xl">{foodEmoji}</span>
                        </div>
                    </a>
                </div>

                <div className="min-w-0 flex-auto text-xs">
                    <p className="text-base font-semibold leading-6 text-white">
                        <a href={mapsUrl} target="_blank" rel="noreferrer"
                           className="font-medium text-white hyphens-auto hover:text-orange-400"
                           restaurantid={restaurantId} restaurantname={name}>
                            {name}
                        </a>
                    </p>
                    {cuisineType && (
                        <p className="mt-1 text-sm font-semibold text-orange-300 capitalize">
                            {cuisineType}
                        </p>
                    )}
                    {(stars != null && stars >= 1 && stars <= 5) && (
                        <p className="text-xs text-yellow-400 mt-0.5">
                            <FontAwesomeIcon icon={faStar} size="xs" className="mr-1" />
                            {stars.toFixed(1)}
                        </p>
                    )}
                    {(area || distanceMiles != null) && (
                        <p className="text-xs text-gray-400 mt-0.5">
                            <FontAwesomeIcon icon={faLocationDot} size="xs" className="mr-1" />
                            {[area, formatDistance(distanceMiles)].filter(Boolean).join(' · ')}
                        </p>
                    )}
                    {opening_hours && (
                        <p className="text-xs text-gray-400 mt-0.5">{opening_hours}</p>
                    )}
                    {phone && (
                        <p className="text-xs text-gray-400 mt-0.5">
                            <FontAwesomeIcon icon={faPhone} size="xs" className="mr-1" />
                            {phone}
                        </p>
                    )}
                    <div className="mt-2">
                        <a href={menuUrl} target="_blank" rel="noreferrer"
                           className="Menu_Button"
                           restaurantid={restaurantId} restaurantname={name}>
                            <FontAwesomeIcon icon={faUtensils} size="xs" className="mr-1" /> menu
                        </a>
                    </div>
                </div>
            </div>

            <div className="shrink-0 flex-col items-end grid grid-cols-2 gap-2 content-start">
                <div className="text-center">
                    <p className="text-base leading-6 text-white">
                        <FontAwesomeIcon icon={faHeart} className="cursor-pointer hover:text-red-500"
                                         clicked="false" restaurantid={restaurantId}
                                         restaurantname={name} size="lg" />
                    </p>
                    <p className="text-base leading-6 text-white mt-2">
                        <a href={mapsUrl} target="_blank" rel="noreferrer"
                           className="font-medium text-white hover:text-orange-400"
                           restaurantid={restaurantId} restaurantname={name}>
                            <FontAwesomeIcon icon={faLink} size="lg" />
                        </a>
                    </p>
                </div>
                <div>
                    <p className="text-base leading-6 text-white">
                        <span id={restaurantId}>0</span>
                    </p>
                    <p className="text-base leading-6 text-white mt-2">
                        <span id={`c_${restaurantId}`}>0</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MyFavoriteRestaurants;
